// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SELECT_TOPIC = "Vyber si kategorii";
export const SEO_TITLE_FORUM_THREAD_NEW_CATEGORY = "Vyber si kategorii";
